var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    {
      attrs: {
        maxlength: _vm.maxLength,
        placeholder: _vm.placeholder,
        disabled: _vm.disabled
      },
      on: { input: _vm.cvInput, blur: _vm.cvBlur },
      model: {
        value: _vm.cv,
        callback: function($$v) {
          _vm.cv = $$v
        },
        expression: "cv"
      }
    },
    [
      _vm.showYuan
        ? _c("template", { slot: "prefix" }, [_vm._v("\n    ￥\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.showYuan ? [_vm._v("\n    元\n  ")] : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5ff2c3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5ff2c3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputAmount.vue
// module id = null
// module chunks = 